export enum SortDirection {
	Ascending = "Ascending",
	Descending = "Descending",
}

export interface Sort<T> {
	direction: SortDirection
	by: T
}
